<template>
    <div class='attributes-container'>
        <ColourPicker :show_selected_colour_text='true' :product='product' @colourClickedListener='colourClicked' :redirect_on_click='redirect_on_click'/>

        <OptionSelectorPlaceholders v-show='!attributes' />
        <div v-for='attribute in attributes' :key='attribute'>
            <OptionSelector :options='attribute' option_title='size' @changeOptionListener='changeOption'/>
        </div>
    </div>
</template>

<script>
import ColourPicker from '@/ecom/components/products/single_product/attributes/ColourPicker.vue';
import OptionSelector from '@/ecom/components/products/single_product/attributes/OptionSelector.vue';
import OptionSelectorPlaceholders from '@/ecom/components/products/single_product/attributes/OptionSelectorPlaceholders.vue';

export default {
    components: {ColourPicker, OptionSelector, OptionSelectorPlaceholders},
    props:{
        product:{
            default: {}
        },
        redirect_on_click:{
            default: true
        }
    },
    emits: ['variantCodeChangeListener', 'colourClickedListener'],
    data(){
        return{
            attributes: []
        }
    },
    methods:{
        changeOption(option, title){
            if(typeof this.product.selected_variant === 'undefined'){
                this.product.selected_variants = [];
            }

            this.product.variant_code = option.code;
            this.product.selected_variant = {
                name: title,
                value: option.value
            }

            this.$emit('variantCodeChangeListener', option);
        },
        colourClicked(product_code, url){
            this.$emit('colourClickedListener', product_code, url);
        }
    },
    watch: {
        'product': function(){
            this.attributes = [];
            
            for (const key in this.product.variants) {
                if(key != 'colours'){
                    this.attributes.push(this.product.variants[key]);
                }

            }
        }
    }
}
</script>

<style lang="scss" scoped>
.attributes-container{
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
}
</style>